import {
  USER_ADD_BALANCE,
  USER_BALANCE_LOGS,
  USER_GET_LOGS_BY_FILTER,
  USER_GET_REQUEST_LOGS,
  USER_GET_REQUEST_LOGS_REPORT,
  USER_GET_REQUEST_LOGS_TYPES,
  USER_INFO,
} from 'features/userPage/core/ReduxNames';

import { get_csv_thunk, get_thunk, post_thunk } from 'services/Api';

import {
  ENDPOINT_ADD_CREDITS,
  ENDPOINT_GET_USER_INFO,
  ENDPOINT_REQUEST_LOGS_FILTER,
  ENDPOINT_REQUEST_LOGS_REPORT,
} from 'services/Endpoints';

const getUserInfo = get_thunk(USER_INFO, ENDPOINT_GET_USER_INFO);
const getUserBalanceLogs = get_thunk(USER_BALANCE_LOGS, ENDPOINT_GET_USER_INFO);
const addUserBalance = post_thunk(USER_ADD_BALANCE, ENDPOINT_ADD_CREDITS);
const getUserRequestLogs = get_thunk(
  USER_GET_REQUEST_LOGS,
  ENDPOINT_GET_USER_INFO,
);
const getUserRequestTypes = get_thunk(
  USER_GET_REQUEST_LOGS_TYPES,
  ENDPOINT_GET_USER_INFO,
);
const getRequestLogsReport = get_csv_thunk(
  USER_GET_REQUEST_LOGS_REPORT,
  ENDPOINT_REQUEST_LOGS_REPORT,
);
const getLogsByFilter = get_thunk(
  USER_GET_LOGS_BY_FILTER,
  ENDPOINT_REQUEST_LOGS_FILTER,
);

export {
  getUserBalanceLogs,
  addUserBalance,
  getUserRequestLogs,
  getUserRequestTypes,
  getRequestLogsReport,
  getLogsByFilter,
};
export default getUserInfo;
